import { createStyles, withStyles, AlertDialog, Typography } from '@paintscout/ui'
import type { WithStyles } from '@paintscout/ui'
import { useDialogs } from '@paintscout/ui-business'
import React, { useEffect } from 'react'
import { useAuth } from 'react-auth0'
import { useLocation, type RouteComponentProps } from 'react-router-dom'
import { clearUserData } from 'shared/util/auth'
import { track } from 'shared/util/analytics'

export interface LogoutProps extends WithStyles<typeof styles>, RouteComponentProps {}

const styles = createStyles({
  root: {
    height: '50vh',
    color: '#757575',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  spinner: {
    marginBottom: 40
  }
})

function Logout(props: LogoutProps) {
  const { classes } = props
  const { logout, session } = useAuth()
  const { openDialog, dismissDialog } = useDialogs()
  const location = useLocation<{ message?: string }>()

  useEffect(() => {
    track('user_logged_out', { reason: location.state?.message ?? 'manual' })
    document.title = 'PaintScout | Logout'

    if (location.state && location.state.message) {
      openDialog(AlertDialog, {
        title: 'Logging Out',
        message: location.state.message,
        onConfirm: () => {
          dismissDialog()
          void clearUserData(session?.app_metadata?.companyId).then(() => logout())
        }
      })
    } else {
      void clearUserData(session?.app_metadata?.companyId).then(() =>
        logout({ logoutParams: { returnTo: process.env.PS_APP_URL as string } })
      )
    }
  }, [])

  return (
    <div className={classes.root}>
      <Typography variant="h5">Logging out...</Typography>
    </div>
  )
}

export default withStyles(styles)(Logout)
